import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconLockedOutline = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        d="M4.205 14.333c-.332 0-.616-.117-.852-.353A1.161 1.161 0 013 13.128V6.872c0-.333.118-.617.353-.852.236-.236.52-.353.852-.353H5V4.333c0-.832.292-1.54.876-2.124A2.893 2.893 0 018 1.333c.832 0 1.54.292 2.124.876.584.584.876 1.292.876 2.124v1.334h.795c.332 0 .616.117.852.353.235.235.353.52.353.852v6.256c0 .333-.118.617-.353.852-.236.236-.52.353-.852.353h-7.59zm0-1h7.59a.2.2 0 00.147-.057.2.2 0 00.058-.148V6.872a.2.2 0 00-.058-.148.2.2 0 00-.147-.057h-7.59a.2.2 0 00-.147.057.2.2 0 00-.058.148v6.256c0 .06.02.11.058.148a.2.2 0 00.147.057zM8 11.167c.324 0 .6-.114.826-.34.227-.228.34-.503.34-.827 0-.324-.113-.6-.34-.826A1.125 1.125 0 008 8.834c-.324 0-.6.113-.826.34-.227.227-.34.502-.34.826 0 .324.113.6.34.826.227.227.502.34.826.34zm-2-5.5h4V4.333c0-.555-.194-1.027-.583-1.416A1.929 1.929 0 008 2.333c-.556 0-1.028.195-1.417.584A1.929 1.929 0 006 4.333v1.334z"
        fill="#01000B"
      />
    </Svg>
  );
};
